import { alpha, darken as muiDarken, lighten as muiLighten } from '@mui/material/styles';

export { alpha };

export const darken = (color: string, coefficient: number): string => muiDarken(color, coefficient);

export const lighten = (color: string, coefficient: number): string =>
  muiLighten(color, coefficient);
